import React from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import RadioGroup from '../../common/RadioGroup';
import Radio from '../../common/Radio';
import styles from './CurrencyTypeSelectionModal.module.scss';
import { currencyTypeOptions } from './currencyTypeOptions';

function CurrencyTypeSelectionModal(props) {
  const { onClose, onConfirm, onChange, currentCheckedValue, supplierCurrency, open = false } = props;
  const radioOptions = currencyTypeOptions(supplierCurrency).map(({ id, value, label }) => (
    <Radio key={id} id={id} value={value} label={label} />
  ));

  return (
    <ModalWindow open={open} onClose={onClose} center>
      <div className={styles.body}>
        <h3>Select currency type for the report</h3>
        <RadioGroup name="currencyTypeSelected" onChange={onChange} selectedvalue={currentCheckedValue}>
          {radioOptions}
        </RadioGroup>
        <div className={styles.footer}>
          <Button onClick={onConfirm} text="OK" />
        </div>
      </div>
    </ModalWindow>
  );
}

export default CurrencyTypeSelectionModal;

CurrencyTypeSelectionModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  currentCheckedValue: PropTypes.string,
  supplierCurrency: PropTypes.string,
};
